import React from 'react';
import Head from 'next/head';
import _ from 'lodash';

interface ProfileHeaderProps {
  title: string;
  links: Array<{
    rel: string;
    href: string;
    hrefLang?: string;
  }>;
  metaTags: Array<Record<string, any>>;
  structureData: string;
  gtm: string;
  isProd: boolean;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  title,
  links,
  metaTags,
  structureData,
  gtm,
  isProd,
}) => (
  <Head>
    <title>{title}</title>
    <link
      rel="icon"
      sizes="192x192"
      href="https://static.wixstatic.com/shapes/0d6674_428e23ed30294cb9ad70d3ae93d06302.svg"
      type="image/x-icon"
    />
    <link
      rel="apple-touch-icon"
      href="https://static.wixstatic.com/shapes/0d6674_428e23ed30294cb9ad70d3ae93d06302.svg"
      type="image/x-icon"
    />
    <link
      rel="shortcut icon"
      type="image/x-icon"
      href="https://static.wixstatic.com/shapes/0d6674_428e23ed30294cb9ad70d3ae93d06302.svg"
    />
    {_.map(links, (attr, index) =>
      attr.rel === 'canonical' ? null : (
        <link
          {...(attr.hrefLang && { hrefLang: attr.hrefLang })}
          rel={attr.rel}
          href={attr.href}
          key={`lang-${index}`}
        />
      ),
    )}
    {_.map(metaTags, (attr, index) => (
      <meta {...attr} key={`meta-${index}`} />
    ))}
    <link
      rel="canonical"
      href={_.get(_.find(links, { rel: 'canonical' }), 'href')}
    ></link>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: structureData }}
    ></script>
    {isProd && <script dangerouslySetInnerHTML={{ __html: gtm }}></script>}
  </Head>
);

export default ProfileHeader;
